<template>
  <el-dialog
    :visible.sync="showDialogVisible"
    title="¿Cómo califica la calidad del servicio brindado?"
    :before-close="handleClose"
    append-to-body
  >
    <el-form ref="form" :model="model" :rules="rules">
      <el-form-item label="" label-width="0" prop="valoracion">
        <star-rating
          @rating-selected="setRating"
          v-model="model.valoracion"
          :show-rating="false"
        />
      </el-form-item>

      <el-row
        :gutter="20"
        v-if="ServiceRequestTypeId !== 7 && ServiceRequestTypeId !== 10"
      >
        <el-col :span="14">
          <el-form-item label="Objetivo" prop="Subject">
            <el-input v-model="model.Subject"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        prop="comentario"
        :label="
          this.model.valoracion < 5 && this.model.valoracion > 0
            ? 'Qué nos faltó hacer para que califique nuestro servicio como excelente?'
            : 'Comentario reportado:'
        "
      >
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Please input"
          v-model="model.comentario"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="onTwoSubmit"
        size="small"
        :loading="loading"
        >Guardar</el-button
      >
      <el-button type="danger" @click="cancelDialog" size="small"
        >Cancelar</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import StarRating from "vue-star-rating";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RecordRating",
  components: {
    StarRating
  },
  data() {
    return {
      loading: false,
      //labelComentario: null,
      rating: "",
      clientCode: "",
      ServiceRequestTypeId: null,
      model: {
        solicitudid: null,
        Code: null,
        Subject: null,
        valoracion: null,
        comentario: null,
        clientCode: null,
        CompanyCode: null,
        ComplaintId: null,
        validationEmployeeID: null,
        FullNameValidationEmployeeID: null,
        limitDate: null,
        closeDate: null,
        SalesPersonCode: null,
        ProductCode: null
      },
      rules: {
        comentario: [
          {
            required: true,
            min: 3,
            message: "Length should be 3",
            trigger: "change"
          }
        ],
        valoracion: [
          {
            required: true,
            message: "La valoracion es requerida",
            trigger: "change"
          }
        ],
        Code: [{ required: true }]
      },
      showDialogVisible: false
    };
  },
  methods: {
    ...mapActions({
      getByCustomerCode: "contact/getByCustomerCode",
      getByProspectCode: "contact/getByProspectCode"
    }),
    show(request) {
      this.rating = "";
      this.model.valoracion = null;
      this.model.comentario = null;
      this.model.Subject = null;
      this.model.solicitudid = request.Id;
      this.model.clientCode = request.ClientCode;
      this.model.Code = request.ContactCode;
      this.model.ComplaintId = this.currentCompany;
      this.model.CompanyCode = this.currentCompany;
      this.model.validationEmployeeID = this.currentUser.EmployeeId;
      this.model.FullNameValidationEmployeeID = this.currentUser.FullName;
      this.model.limitDate = request.DueDate;
      this.model.closeDate = request.ServiceRequestCloseDate;
      this.model.SalesPersonCode = request.Customer.SalesPersonCode;
      this.model.ProductCode = request.ProductId;
      this.showDialogVisible = true;

      this.clientCode = request.ClientCode;
      this.ServiceRequestTypeId = request.ServiceRequestTypeId;
    },

    onTwoSubmit() {
      const limitDate = new Date(this.model.limitDate);
      const closeDate = new Date(this.model.closeDate);
      if (this.model.valoracion == 5 && closeDate > limitDate) {
        this.$message({
          type: "error",
          message:
            "Solicitudes con SLA vencidos no podrán ser calificadas con 5 estrellas"
        });
        this.model.valoracion = 0;
      } else {
        this.onSubmit();
        this.OnSubmitEmployeeIdValoration();
      }
    },
    onSubmit() {
      //this.labelComentario = this.model.valoracion < 5 ? "Qué nos faltó hacer para que califque nuestro servicio como excelente?" : "Comentario reportado:"
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const date = this.$now();
          this.$http
            .post("/api/serviceRequests/RegisterQualify", this.model)
            .then((resp) => {
              console.error(resp);
              this.showDialogVisible = false;
              this.$message.success("Calificacion exitosa");
              this.$emit("rating-success");

              if (
                this.ServiceRequestTypeId !== 7 &&
                this.ServiceRequestTypeId !== 10
              ) {
                this.$store
                  .dispatch("interactions/create", {
                    ContactNumber: this.model.Code, //Colocar el clientCode
                    ContactCompanyNumber: this.model.clientCode,
                    Date: date,
                    Description: this.model.comentario
                      .replace("<p>", "")
                      .replace("</p>", ""),
                    InitiatedBy: 1,
                    InteractionTemplate: "LLAMADA_VS",
                    Subject: this.model.Subject,
                    UserName: this.currentUser.UserName,
                    Time: date,
                    ProductCode: this.model.ProductCode,
                    UserID: this.currentUser.UserID,
                    CustomerServiceExec_: this.currentUser.CustomerServiceExec_,
                    SalesPersonCode: this.model.SalesPersonCode,
                    CompanyId: this.currentUser.CompanySelected
                  })
                  .then(() => {
                    this.$message({
                      type: "success",
                      message: "Interaccion creada!"
                    });
                  });
              }
            })
            .catch((error) => {
              this.showDialogVisible = false;
              console.error(error);
            })
            .finally(() => (this.loading = false));
        } else {
          this.shoDialogVisible = true;
          return false;
        }
      });
    },
    OnSubmitEmployeeIdValoration() {
      let RequestID = this.model.solicitudid;
      let EmployeeID = this.currentUser.EmployeeId;

      this.loading = true;
      this.$http
        .get("/api/serviceRequests/InsertValidationEmployeeID", {
          params: {
            RequestID: RequestID,
            EmployeeID: EmployeeID
          }
        })
        .then((resp) => {
          this.data = resp.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setRating(rating) {
      this.model.valoracion = rating;
    },
    handleClose(done) {
      this.$refs.form.resetFields();
      this.model = {
        solicitudid: null,
        valoracion: 0,
        comentario: null,
        clientCode: null,
        CompanyCode: null,
        ComplaintId: null,
        validationEmployeeID: this.currentUser.EmployeeId,
        FullNameValidationEmployeeID: this.currentUser.FullName
      };
      done();
    },
    cancelDialog() {
      this.showDialogVisible = false;
      this.$refs.form.resetFields();
      this.model = {
        solicitudid: null,
        valoracion: 0,
        comentario: null,
        clientCode: null,
        CompanyCode: null,
        ComplaintId: null,
        validationEmployeeID: this.currentUser.EmployeeId,
        FullNameValidationEmployeeID: this.currentUser.FullName
      };
    }
  },
  computed: {
    ...mapGetters({
      listContact: "contact/list_to_select",
      list_interaction_code_to_select:
        "interactions/list_interaction_code_to_select",
      list_products: "products/list_products"
      //loading: "contact/isLoading"
    })
  },
  watch: {
    IsVisible(val) {
      if (val) {
        this.drawer = true;
      } else {
        this.drawer = false;
      }
    },
    clientCode(val) {
      if (this.isProspect) {
        this.getByProspectCode({
          contactCode: val
        });
      } else {
        this.getByCustomerCode({
          customerCode: val
        });
      }
    }
  }
};
</script>
